import React from "react";
import { createCSVFile, csvHeaders, importCSVFile } from "../../schema/Csv";
import CSVReader from "../../CSVReader";

interface CreateDragDropProps {
  selectedScope: string;
  setData: (data: any) => void;
}

function DragDrop(props: CreateDragDropProps) {
  const templateCSV = (name: string, data: any) => {
    let email = "example@example.org";
    let headers = csvHeaders(email, data);

    const blob = new Blob(
      [
        createCSVFile(headers, {
          [email]: data,
          "development@mynext.id": data,
        }),
      ],
      { type: "text/csv" }
    );
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", "template_" + name + ".csv");
    a.click();
  };

  return (
    <>
      <label>
        Upload File (see{" "}
        <span
          className="hyperlink"
          onClick={() => {
            templateCSV(props.selectedScope, {});
          }}
        >
          example.csv
        </span>
        )
      </label>
      <label htmlFor="images" className="drop-container-csv">
        <span className="drop-title">Drop files here</span>
        or
        <CSVReader
          onUpload={(results: any) => {
            props.setData(importCSVFile(results.data as string[][]));
          }}
          onRemove={(onRemove: any) => {
            props.setData({});
          }}
        ></CSVReader>
      </label>
    </>
  );
}
export default DragDrop;
